import "./topPicks.scss";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import backbtn from "../../../assets/images/backbutton.svg";
import {
  GetProductTopPicks,
  IsTopPicks,
  LoadingNumber,
  SetAllTopPicksProducts,
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  resetLoadingNumber,
} from "../../../features/Products/ProductSlice";
import palceholderimage from "../../../assets/images/palceholderimage.webp";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { useTranslation } from "react-i18next";
import branch from "branch-sdk";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ProductCard from "../../Static/Shared/ProductCard";
import { UserContext } from "../../../context/user.context";
import LoadingComp from "../LoadingComp";
import { getOnlineProductsTopPicks } from "../../../utils/firebase/firebase.utils";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";

import viewall from "../../../assets/images/view-all.svg";
import viewmore from "../../../assets/images/HomePage/arrowR.svg";
import left from "../../../assets/images/HomePage/arrowL.svg";

function TopPicks() {
  const dispatch = useDispatch();
  const [activeThumb, setActiveThumb] = useState();
  const { currentUser } = useContext(UserContext);
  const { flags } = useSelector((store) => store.flags);
  const [showSignin, setShowSignin] = useState(false);

  const { products, loadnb, topPicksProducts } = useSelector(
    (store) => store.allproducts
  );
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  var arrayFortSort = []; //[...products.filter((product)=>product.userLikes)];
  const now = new Date();
  var datenow = new Date();
  datenow.setDate(now.getDate());

  var isFlash = false;

  if (flags.filter((flag) => flag.id === "offers")[0]) {
    const endDate = flags.filter((flag) => flag.id === "offers")[0]
      .endFlashSale;
    const startDate = flags.filter((flag) => flag.id === "offers")[0]
      .startFlashSale;
    isFlash =
      "toDate" in endDate && "toDate" in startDate
        ? flags.filter((flag) => flag.id === "offers")[0].isFlashSale &&
          startDate.toDate() <= Date.now() &&
          endDate.toDate() >= Date.now()
        : false;
  }

  const [loading, setLoading] = useState(true);

  var TopPicks;

  useEffect(() => {
    const fetchProducts = async () => {
      dispatch(GetProductTopPicks([]));
      dispatch(IsTopPicks(false));

      try {
        // Fetch more products than needed for better shuffling variety
        const map = await getOnlineProductsTopPicks(null, 100);

        let shuffledProducts = [];
        if (map?.products?.length > 0) {
          // Use the shuffleArray function to randomize the products
          shuffledProducts = shuffleArray(map.products);
        }

        // Apply the filters after shuffling
        let topPicks = [];
        if (shuffledProducts.length > 0) {
          topPicks = shuffledProducts.filter(
            (product) =>
              product?.userLikes?.length > 0 && product?.status === "Live"
            // &&
            // isLessThan90(product.date)
          );
        }

        // Take only the first 10 products (or fewer if fewer match the criteria)
        const displayProducts = topPicks.slice(0, 10);

        dispatch(SetAllTopPicksProducts(displayProducts));
      } catch (error) {
        console.error("Error fetching top picks:", error);
      }
    };

    fetchProducts();
  }, []);

  const isLessThan90 = (date) => {
    if ("toDate" in date) {
      return (datenow - date.toDate()) / (1000 * 3600 * 24) < 90;
    } else {
      return false;
    }
  };

  const shuffleArray = (array) => {
    const newArray = [...array]; // Create a copy to avoid modifying original
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

    return !isLastItemVisible ? (
      <div
        disabled={isLastItemVisible}
        className="align-items-center d-flex"
        onClick={() => scrollNext()}
      >
        {topPicksProducts.length > 4 ? (
          // <img src={viewmore} className="plusbtn" />
          <div class="image-container-arrow">
            <img
              src={left}
              alt="right arrow"
              className="arrow-default rotate180"
            />
            <img src={viewmore} alt="right arrow" className="arrow-hover " />
          </div>
        ) : null}
      </div>
    ) : (
      <></>
    );
  }
  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

    return !isFirstItemVisible ? (
      <div
        disabled={isFirstItemVisible}
        className="align-items-center d-flex"
        onClick={() => scrollPrev()}
      >
        {topPicksProducts.length > 4 ? (
          // <img src={left} className="plusbtn me-3" />
          <div class="image-container-arrow">
            <img src={left} alt="right arrow" className="arrow-default" />
            <img
              src={viewmore}
              alt="right arrow"
              className="arrow-hover rotate180"
            />
          </div>
        ) : null}
      </div>
    ) : (
      <></>
    );
  }

  useEffect(() => {
    if (TopPicks) {
      setLoading(false);
    }
  }, [products]);
  useEffect(() => {
    dispatch(SetSelectdPage(0));
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    sessionStorage.setItem("selectedItemIndex", "");
    dispatch(resetLoadingNumber(30));
  }, []);
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }
  return (
    <>
      <div className="montserrat-font d-flex align-items-center">
        <h1
          className={`montserrat-font title-section px-md-5  pt-lg-5 pt-4 ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
        >
          {t("MostWhished")}
        </h1>
        <div style={{ flexGrow: 1 }} />
        <a
          className={`d-flex justify-content-center shoptopick px-lg-0 px-3  pt-lg-5 pt-4 me-md-5  ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
          onClick={() =>
            dispatch(IsTopPicks(true)) &
            navigate(`/products?topic=TopPicks`) &
            dispatch(SetSearch("")) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          style={arabStyle}
          aria-label="Shop Top Picks - View All Top Picks"
        >
          {i18n.language == "en" ? (
            <>
              <div
                className={`me-2 shoptopick ${
                  i18n.language == "en" ? `text-start` : `text-startAr`
                }`}
              >
                {t("viewall")}
              </div>

              <img
                src={viewall}
                style={{ width: "19px" }}
                className="plusbtn"
                alt="main"
              />
            </>
          ) : (
            <>
              {" "}
              <img
                src={backbtn}
                style={{ width: "98px" }}
                className="plusbtn"
                alt="main"
              />
            </>
          )}
        </a>
      </div>

      {/* className="d-lg-none d-block sub-section px-lg-5 px-3 pb-4 pb-lg-5"  style={arabStyle} */}
      <h2 className="sub-section px-md-5 pt-md-2 ">{t("home-sub4")}</h2>

      {!topPicksProducts || topPicksProducts.length == 0 ? (
        <LoadingComp heightcomp="newdropsheight" />
      ) : (
        <div>
          {topPicksProducts.length > 4 ? (
            <>
              <div className="d-md-block d-none">
                <div
                  className="  padding-inlineCards px-md-5 px-0 pb-md-5"
                  dir={i18n.dir("en")}
                >
                  <ScrollMenu
                    LeftArrow={LeftArrow}
                    RightArrow={RightArrow}
                    className=" padding-inlineCards px-md-5 px-0  pt-md-5 pb-md-5 d-md-block d-none"
                    id="style-2"
                  >
                    {topPicksProducts.slice(0, 15).map((card) => (
                      <ProductCard
                        card={card}
                        currentUser={currentUser}
                        isFlash={isFlash}
                      />
                    ))}
                  </ScrollMenu>

                  {/* </div> */}
                </div>
              </div>
              <div className="container-fluid px-0 pt-md-0 pt-2 me-0 d-md-none d-flex ">
                <div
                  className="  d-flex flex-row  scroll flex-nowrap padding-inlineCards px-md-5 px-0  pt-md-5 pb-md-5"
                  dir={i18n.dir("en")}
                >
                  {topPicksProducts.slice(0, 4).map((card) => (
                    <ProductCard
                      card={card}
                      currentUser={currentUser}
                      isFlash={isFlash}
                    />
                  ))}
                  {/* </div> */}
                </div>
              </div>
            </>
          ) : (
            <div className="container-fluid p-0 me-0 d-flex">
              {topPicksProducts.slice(0, 4).map((card) => (
                <ProductCard
                  card={card}
                  currentUser={currentUser}
                  isFlash={isFlash}
                  setShowSignin={setShowSignin}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default TopPicks;
